import React from "react";
import styled from "styled-components";
import CallOutlinedIcon from "@material-ui/icons/CallOutlined";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import LockOpenOutlined from "@material-ui/icons/LockOpenOutlined";
import PersonAddOutlined from "@material-ui/icons/PersonAddOutlined";
import { Text } from "../vendor/roar/text";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory  } from "react-router-dom";
import { GroupAddOutlined } from "@material-ui/icons";
import PropTypes from 'prop-types';

const Style = styled.div`
  .header-container {
    height: 120px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .naf-logo {
    width: 56px;
    height: 56px;
    border-radius: 4px;
  }
  .logo-text {
    display: flex;
    flex-direction: column;
    -webkit-box-pack: center;
    justify-content: center;
    margin: 0px 0px 8px 40px;
    font-size: 20px;
  }
  a:hover {
    color: rgb(38, 124, 79);
    text-decoration: underline;
  }
  a {
    text-decoration: none;
  }
  .header-icons-container {
    display: flex;
    flex-direction: row;
    gap: 40px;
  }
  .icon-button {
    display: flex;
    gap: 8px;
    align-items: center;
    cursor: pointer;
    border:none;
    backgroundColor:transparent;
    background:transparent;
    backgroundColor:none;
  }
`;
export default function Header(props) { 
  const setReset = props.setReset;
  const { logout } = useAuth0();
  const { isAuthenticated } = useAuth0();
  const logoutHandler = () => {
    logout({
      returnTo: window.location.origin,
    });
  };
  const { loginWithRedirect } = useAuth0();
  const history = useHistory();
  
  return (
    <Style>
      <div className="header-container">
        <div className="d-flex  align-items-center h-100">
          <a href="/register">
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 300 300"><path fill="#FFDC00" d="M12.2 0C5.5 0 0 5.5 0 12.2v275.7c0 6.7 5.5 12.1 12.2 12.1h275.7c6.7 0 12.1-5.5 12.1-12.1V12.2C300 5.5 294.5 0 287.9 0H12.2z" /><path d="M264.8 173.5c-.9-13.3-12-21.2-20.3-26.4l-29.2-18c-12.7-8-18-19.6-12.1-30.4 2.5-4.6 6.7-8 10.6-8.8 2.9-.6 5.2.1 6.8.9 1.5.8 2.9 2.1 3.3 3.1 2.4 5.5-4.6 6.9-5.7 13.4-1.5 9.5 8.2 11.3 8.2 11.3s.3-2.1 1.7-4.4c11.7-17.4.8-25.3-1.4-27-3-2.2-8.3-4.2-14.4-2.9-4 .9-10.7 4-15.3 11.8-8.2 14.1-2.8 28.1 13.2 39l28.5 19.2c7.3 4.9 16.2 10.7 15.2 20.9-.6 5.5-2.4 7.9-6.8 10.2-5.4 2.9-15 .7-22.9-3.4-25.7-13.3-49.6-37.7-52.5-58.4 12.2-31.5 10.4-52.7-4-70.2-14.7-17.9-41-17.2-43.5-14.7l-4.1 11.9c-7.1 3.9-12.6 11.1-12.6 11.1l-1.1 4.1s-13.7 12.9-12 15.9c1.7 3.1 6.6 6.5 6.6 6.5s2.3-5.7 9.3-5.7c7.6 0 8.7 7.9 6.1 11.1-2.7 3.3-10.5 3.9-10.5 3.9l6.7 8.1s2-2.7 7.3-7.4c3.2-2.9 6.9.9 4.1 4.1-2.7 3-10.7 12.4-16.4 22.4-10.1 18-5.6 31-1.5 37.8-3.4 7.8-14.2 32.1-14.6 32.8-3 5.4-14.2 9-17.4 10.3 0 0-1.2 4.6-1.1 8.8v.1c0 1 .1 1.9.3 2.8 1.3 5.3 6.1 9.3 11.8 9.3 6.7 0 12.2-5.4 12.2-12.2 0-1.6-.3-3-.8-4.4 2.4-2.5 31.3-32.8 31.8-33.2.8-.7 2.4-3.1 2.5-5.9v-4.5c0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.7 1.2 2.7 2.7v12.8c14.4 1 24.3 3.4 37.9 9.8l5.4-2.4c2.9 2.9 8.6 30.4 8.6 30.4s29.2 14.6 36.8 18.3c7.6 3.7 3.1 8 1.7 10.3-1.4 2.3-5.6 6.4-5.6 6.4s-6.8-.4-14.3-1.8c-3.1 2.3-4.7 8.6-5.2 11.2h27.6c1.9-3.3 13.9-18.1 13.9-18.1.4-5.1-1.6-13.2-8.1-23.2-5.3-8.2-7-16.2-8.2-24.1 13.6 4.2 24.5.3 30.6-4.9 4.8-3.9 8-10.7 7.5-17.6zM113.4 69.1l-2.3-3.6s5.4-2.7 9.5-2.1c0 0-4.5 2.4-7.2 5.7zm69.9 149.2c-1-4.6-1.6-7.4-3.2-14-1.9-7.8-5.9-9.5-7.3-10.1l-3.3-1.5c-1.9 1.4-7.9 11.7-2.6 23.3 2.3 5 5.7 16 6.6 20.7 1.6 7.9.1 9.3-1.7 11.3-2.3 2.5-5.6 4.5-5.6 4.5-.6 0-1.1 0-1.6.1-2.6-.2-8-.7-13-1.7-2.9 2.5-4.6 8.3-5.1 11H174l17.1-19.3c.3-3.6.4-7.2 1.4-17.5l-6.3-3.1c-1.7-.9-2.6-2.2-2.9-3.7zm-70.9-16.8c1.9 4 3 8.5 3 13.2 0 16.7-13.5 30.2-30.2 30.2S55 231.4 55 214.7s13.5-30.2 30.2-30.2c1.8 0 3.6.2 5.4.5 2.4-5.4 7.3-16.4 7.3-16.4-4-1.1-8.3-1.7-12.6-1.7-26.4 0-47.8 21.4-47.8 47.8 0 16.3 8.1 30.6 20.5 39.3 0 0 .1 0 .1.1 1.8 1.3 3.8 2.4 5.8 3.4.1 0 .2.1.3.1.4.2.9.4 1.3.6.1 0 .3.1.4.2.4.2.9.4 1.3.6.1 0 .3.1.4.1.5.2.9.4 1.4.5.1 0 .2.1.2.1 2.1.8 4.3 1.4 6.6 1.8.1 0 .2 0 .3.1.2 0 .4.1.5.1h.1c2.8.5 5.6.8 8.5.8 2.9 0 5.8-.3 8.5-.8h.3c22.3-4.1 39.1-23.6 39.1-47 0-9.8-3-18.9-8-26.5 0 0-8.4 8.9-12.7 13.3zm.2-112.8c-10-1.1-11.5 9.9-21.1 6.9 0 0 2 4.4 6.8 3.6 5.6-.9 5.8-8.4 14.3-10.5z" /></svg>
          </a>
          <a
            href="tel:+47-08505"
            className="d-flex flex-direction-column logo-text"
          >
            <Text
              style={{
                margin: 0,
                lineHeight: "26px",
              }}
              tag="span"
              variant="bodyLarge"
            >
              Veihjelp
            </Text>
            <div style={{ fontWeight: 700 }}>08505 </div>
          </a>
        </div>
        <div className="header-icons-container">
        {isAuthenticated && props.isAdmin && (
            <button
              className="icon-button"             
              onClick={() => {
                history.push("/users");
              }}
            >
              <Text
                style={{
                  margin: 0,
                }}
                tag="span"
                variant="bodyLarge"
              >
                Users{" "}
              </Text>
              <GroupAddOutlined />
            </button>
          )}
          {isAuthenticated && (
            <button
              className="icon-button"
              onClick={() => {
                setReset(true);
                history.push("/register");
              }}
            >
              <Text
                style={{
                  margin: 0,
                }}
                tag="span"
                variant="bodyLarge"
              >
                Legg til medlem{" "}
              </Text>
              <PersonAddOutlined />
            </button>
          )}

          {isAuthenticated && (
            <button className="icon-button" onClick={logoutHandler}>
              <Text
                style={{
                  margin: 0,
                }}
                tag="span"
                variant="bodyLarge"
              >
                Logg ut
              </Text>
              <LockOpenOutlined />
            </button>
          )}
          {!isAuthenticated && (
            <button className="icon-button" onClick={loginWithRedirect}>
              <Text
                style={{
                  margin: 0,
                }}
                tag="span"
                variant="bodyLarge"
              >
                Logg inn
              </Text>
              <LockOutlinedIcon />
            </button>
          )}

          
          <a href="tel:+47-23213101" className="icon-button">
            <Text
              style={{
                margin: 0,
              }}
              tag="span"
              variant="bodyLarge"
            >
              +47 23 21 31 01
            </Text>
            <CallOutlinedIcon />
          </a>
        </div>
      </div>
    </Style>
  );
}
Header.propTypes = {
  isAdmin: PropTypes.bool,
  setReset: PropTypes.func, 
};
